(() => {
  if (customElements.get("component-tabs")) {
    return;
  }

  class ComponentTabs extends HTMLElement {
    constructor() {
      super();
      this.tabsHead = this.querySelectorAll("[data-head] a");
      this.tabsBody = this.querySelectorAll("[data-body] [data-tab]");
    }

    connectedCallback() {
      this.tabsHead.forEach((e) =>
        e.addEventListener("click", this.toggle.bind(this))
      );

      if (window.location.hash) {
        this.update(window.location.hash);
      }
    }

    toggle(e) {
      e.preventDefault();
      const id = e.currentTarget.dataset.id;
      this.update(id);
    }

    update(id) {
      this.tabsHead.forEach((t) => {
        t.removeAttribute("active");
      });

      this.querySelector(`[data-id="${id}"]`).setAttribute("active", "");

      history.pushState(null, null, id);

      this.tabsBody.forEach((t) => {
        t.setAttribute("hidden", "");
      });
      this.querySelector(id).removeAttribute("hidden");
    }
  }

  customElements.define("component-tabs", ComponentTabs);
})();
